﻿/**
 * Subtle slowly-moving glowing lines rendered as SVG — sits fixed behind
 * all page content, creating the cinematic "depth lines" effect.
 */
export default function AmbientLines() {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      zIndex: 0, pointerEvents: 'none',
      overflow: 'hidden',
    }}>
      <svg
        width="100%" height="100%"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, opacity: 0.35 }}
      >
        <defs>
          <linearGradient id="lg1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   stopColor="#06b6d4" stopOpacity="0" />
            <stop offset="30%"  stopColor="#06b6d4" stopOpacity="0.5" />
            <stop offset="70%"  stopColor="#06b6d4" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#06b6d4" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="lg2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   stopColor="#67e8f9" stopOpacity="0" />
            <stop offset="40%"  stopColor="#67e8f9" stopOpacity="0.3" />
            <stop offset="60%"  stopColor="#67e8f9" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#67e8f9" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Horizontal glowing lines at various vertical positions */}
        <line x1="0" y1="180" x2="1440" y2="180" stroke="url(#lg1)" strokeWidth="0.5">
          <animateTransform attributeName="transform" type="translate" from="-1440 0" to="0 0" dur="18s" repeatCount="indefinite" />
        </line>
        <line x1="0" y1="420" x2="1440" y2="420" stroke="url(#lg2)" strokeWidth="0.4">
          <animateTransform attributeName="transform" type="translate" from="0 0" to="-1440 0" dur="24s" repeatCount="indefinite" />
        </line>
        <line x1="0" y1="660" x2="1440" y2="660" stroke="url(#lg1)" strokeWidth="0.5">
          <animateTransform attributeName="transform" type="translate" from="-720 0" to="720 0" dur="20s" repeatCount="indefinite" />
        </line>

        {/* Diagonal subtle line */}
        <line x1="-200" y1="0" x2="600" y2="900" stroke="#06b6d4" strokeOpacity="0.06" strokeWidth="0.5">
          <animateTransform attributeName="transform" type="translate" from="0 0" to="1440 0" dur="30s" repeatCount="indefinite" />
        </line>
        <line x1="400" y1="0" x2="1200" y2="900" stroke="#67e8f9" strokeOpacity="0.04" strokeWidth="0.5">
          <animateTransform attributeName="transform" type="translate" from="1440 0" to="0 0" dur="35s" repeatCount="indefinite" />
        </line>
      </svg>
    </div>
  )
}
